import Chart from "react-apexcharts";
import { Loading } from "../../../componentes/loading/loading";
import { reduzirNome } from "../../../utils/reduzirNome";

export function ErrosPorMontador({ report, loading }) {
  const nomes = Object.keys(report.caixasPorMontador || {});
  const montadores = Array.from(new Set([
    ...nomes,
    ...Object.keys(report.paletesPorMontador || {}),
    ...Object.keys(report.errosPorMontador || {}),
  ]));

  const errosPorMontador = montadores.map((n) => Number(report.errosPorMontador?.[n] || 0));

  const pieOptions = {
    chart: { type: "pie" },
    colors:      [
        "#ee1d1dff", "#FF7F00", "#dfdf31ff", "#21e421ff", "#23ddddff",
        "#1a1ae7ff", "#861adfff", "#FF1493", "#FF4500", "#32CD32",
        "#1E90FF", "#FFD700", "#DC143C", "#00CED1", "#FF69B4",
        "#FF6347", "#7CFC00", "#40E0D0", "#FF00FF", "#FF8C00"
      ]    ,
    labels: montadores.map(x => reduzirNome(x)),
    legend: { position: "bottom" },
    stroke: {
      show: false,
      width: 0
    },
  };

  return (
      <div style={{ height: 320 }}>
        {!loading ? (
          <Chart options={pieOptions} series={errosPorMontador} type="pie" height="100%" />
        ) : (
          <Loading />
        )}
      </div>
  );
}